<template>
    <v-dialog-old ref="dialog" id="feedbackRequestFromExelDialog" @hidden="resetData">

            <ValidationObserver ref="importExcelForm">
                <form style="overflow:initial !important;">
                    <drag-and-drop @fileDropped="filePrepare">
                        <v-loading-component ref="loadingDialog">
                            <template slot-scope="{ loadingClass }">
                                <fieldset :class="[loadingClass]" style="min-height: 280px; overflow: unset;">
                                    <legend>Импорт из EXCEL</legend>
                                    <div v-if="file.formData=== ''"  class="dropper-box"  >
                                        <a href="#"  @click.prevent="downloadBlade">Скачать шаблон файла для импорта</a>

                                        <button  class="button-add-file" @click.prevent="showFileChooser"><i class="far fa-folder-open" aria-hidden="true"/> Добавьте файл...</button>
                                        <div id="dropZoneContainer">
                                            <div>Перетяните файл сюда</div>
                                        </div>

                                    </div>
                                    <div v-else>
                                        <label>Файл</label>
                                        <v-input v-model="file.name" disabled @clearData="clearFileData"/>
                                    </div>

                                    <table v-if="parsedData.length" class="table" style="table-layout: fixed;">
                                        <thead>
                                            <tr>
                                                <th>Имя</th>
                                                <th>Телефон</th>
                                                <th>Дата визита</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in parsedData" class="hover" :class="{tr__error: item.error}" v-tooltip="item.error? item.error: ''">
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.phone }}</td>
                                                <td>{{ item.visit_date | formatDate }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </fieldset>
                            </template>
                        </v-loading-component>
                    </drag-and-drop>
                </form>
            </ValidationObserver>

        <template v-slot:footer>
            <v-loading-component ref="submitBtn" @click="submit">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: canStepUp && !btnDisabled}, loadingClass]" :disabled="btnDisabled">
                        Загрузить
                    </button>
                </template>
            </v-loading-component>
        </template>
        <input type="file"
               style="display: none"
               :accept="allowedTypes.join(',')"
               ref="uploadInput"
               @input="fileChoose"
        />
    </v-dialog-old>
</template>
<script>
import dragAndDrop from '@base/DragAndDrop.vue';
export default {
    components: {
        dragAndDrop
    },
    data: function () {
        return {
            file: {
                name: '',
                formData: ''
            },
            btnDisabled: false,
            allowedTypes: [
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel"
            ],
            parsedData: []
        }
    },
    methods: {
      downloadBlade() {
        window.open('https://manager.doctu.ru/storage.public/files/Шаблон_импорта_списка_запросов.xlsx');
      },
        showFileChooser() {
            setTimeout(() => {
                this.$refs.uploadInput.click();
            }, 50)
        },
        fileChoose(event){
            if (event.target.files.length) {
                this.filePrepare(event.target.files[0])
            }
        },
        clearFileData(){
            this.$refs.uploadInput.value = '';
            this.file = {
                name: '',
                formData: ''
            }

            this.parsedData = []
        },
        show () {
            this.$refs.dialog.show();
        },
        hide() {
            this.resetData();
            this.$refs.dialog.hide();
        },
        submit(btn) {
            if(this.parsedData.some(row => row.error !== undefined)){
                this.$root.showErrorDialog({
                    message: 'Невозможно загрузить данные. Файл содержит ошибки.'
                });
                return;
            }
            if(!this.canStepUp || this.btnDisabled){
                return;
            }
            this.btnDisabled = true;
            btn.startLoadingAnimation();
            this.axios.post('requests/createFromExcel/', {parsedData: this.parsedData})
                .then((response) => {
                    this.btnDisabled = false;
                    btn.stopLoadingAnimation()
                    this.$emit('updated');
                    this.hide()
                });
        },
        resetData(){
            this.file = {
                name: '',
                formData: ''
            };
            this.btnDisabled = false;
            this.parsedData = []
        },
        filePrepare(file) {
            if(this.allowedTypes.indexOf(file.type) === -1 ){
                this.$root.showErrorDialog({
                    message: 'Некорректный тип файла!'
                });
                return;
            }
            let reader = new FileReader();
            this.file.name = file.name
            let formData = new FormData();
            formData.append('import', file)
            this.file.formData = formData;

            reader.onerror = function (error) {
                console.log('Error: ', error);
            };

            this.startParsing()
        },
        startParsing(){
            if(!this.canStepUp || this.btnDisabled){
                return;
            }
            this.btnDisabled = true;
            this.$refs.loadingDialog.startLoadingAnimation();
            this.axios.post('requests/uploadExcelFile', this.file.formData)
                .then((response) => {
                    const data = response.data.data;
                    const firstError = data.length === 1 && data[0]?.error;

                    if (firstError) {
                        this.$root.showErrorDialog({
                            message: firstError
                        });
                        this.resetData();
                    } else {
                        this.parsedData = data;
                        this.btnDisabled = false;
                    }

                    this.$refs.loadingDialog.stopLoadingAnimation();
                }, () => {
                    this.btnDisabled = false;
                    this.$refs.loadingDialog.stopLoadingAnimation()
                });
        }

    },
    computed: {
        canStepUp() {
            return this.file.formData !== ''
        }
    }
}
</script>
<style lang="scss">
#feedbackRequestFromExelDialog{
    width: 600px;

    .tr__error {
        background: red !important;

        &:hover{

        }
    }
    .tr__error td {
        border-color: #e23d3d;
    }
}

</style>
